import { useEffect, useState } from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap"
import { HANDLE_EVENT_CHARACTER, PLAYER_CONFIG, RESOURCES_ID, TIMEOUT_ONLINE } from "../../constants/Common";
import { startGame, stopGame } from "../../services/authService";
import { SCREEN_SETTING } from "../../constants/screenRouter";
import SettingSeaFood from "./SettingSeaFood";
import SettingQuanDoan from "./SettingQuanDoan";
import CharacterMap from "./CharacterMap";
import PlayerInfo from "./PlayerInfo";
import PlayerSeaFood from "./PlayerSeaFood";
import useSettingScreen from "../../hooks/useSettingScreen";
import useOnlineInfo from "../../hooks/useOnlineInfo";
import { toast } from "react-toastify";
import { DANG_QUOC_CHIEN, DONE_QUOC_CHIEN, ERROR_START_PLAYER, STARTED_PLAYER, STARTING_PLAYER } from "../../constants/errMessage";
import { TOAST_TYPE, updateToastPromise } from "../../contexts/ToastProvider";
import usePlayerInfo from "../../hooks/usePlayerInfo";
import { getLocalStorage } from "../../utils/localStorage";
import { STORAGE_KEY } from "../../constants/storageKeys";
import PlayerQuocChien from "./PlayerQuocChien";
import ExtendFunction from "./ExtendFunction";
import useQcAutoOnline from "../../hooks/useQcAutoOnline";
import { stringToShort } from "../../utils/common";
let idTimeOutStarting = null;
let idToastStarting = null;
const Character = ({ playerId, isFarmingSeaFood, onClick = null }) => {
    const [starting, setStarting] = useState(false);

    const { screen, gotoScreen } = useSettingScreen(playerId);

    const { online } = useOnlineInfo(playerId);

    const { playerInfo } = usePlayerInfo(playerId)

    const { qcAuto } = useQcAutoOnline(playerId);
    const [toastQCPromiseId, setToastQCPromiseId] = useState(null);
    const localUserInfo = getLocalStorage(STORAGE_KEY.USER_INFO);


    const onlineColor = () => {
        if (online) return "success"
        return "danger"
    }

    const setTimoutStarting = () => {
        clearTimeout(idTimeOutStarting);
        idTimeOutStarting = setTimeout(() => {
            setStarting(false);
            if (idToastStarting != null) updateToastPromise(idToastStarting, ERROR_START_PLAYER, TOAST_TYPE.ERROR)
        }, TIMEOUT_ONLINE * 1.2);
    }

    useEffect(() => {
        // console.log('Character UseEffect', playerId, online, idToastStarting)
        clearTimeout(idTimeOutStarting);
        if (online === true) {
            setStarting(false);
            if (idToastStarting != null) updateToastPromise(idToastStarting, STARTED_PLAYER, TOAST_TYPE.SUCCESS);
            idToastStarting = null;
        } else {
            setStarting(false);
            if (idToastStarting != null) updateToastPromise(idToastStarting, ERROR_START_PLAYER, TOAST_TYPE.ERROR);
            idToastStarting = null;
        }
    }, [online])

    const handleStart = () => {
        setStarting(true);
        if (idToastStarting == null) idToastStarting = toast.loading(STARTING_PLAYER)
        //console.log('handleStart');
        const payload = {
            user: {
                token: playerInfo.Token,
                userId: playerInfo.UserId,
                userName: playerInfo.UserName
            },
            player: {
                country: playerInfo.Country,
                level: playerInfo.Level,
                playerId: playerInfo.Id,
                name: playerInfo.Name
            },
            server: {
                id: playerInfo.ServerId,
                name: playerInfo.ServerName,
                shortName: playerInfo.ShortName,
                port: playerInfo.Port
            }
        }
        const userInfo = getLocalStorage(STORAGE_KEY.USER_INFO)
        if (userInfo.password != null) payload.player.token = userInfo.password;
        startGame(payload).then((res) => {
            if (res.error == false) {

            } else {
                updateToastPromise(idToastStarting, ERROR_START_PLAYER, TOAST_TYPE.ERROR);
                idToastStarting = null;
            }
        })
        setTimoutStarting();

        if (onClick != null) onClick(HANDLE_EVENT_CHARACTER.START_GAME, payload);

    }

    const handleStop = () => {
        //console.log('handleStop');
        const payload = { playerId: playerInfo.Id }
        stopGame(playerId);

        if (onClick != null) onClick(HANDLE_EVENT_CHARACTER.STOP_GAME, payload);
    }

    const showPlayerName = () => {
        const playerName = playerInfo.Name;
        const userName = playerInfo.UserName;
        const localUserName = localUserInfo.Username;
        if (localUserName === userName) return (
            <span>
                {playerName}
            </span>
        );
        else return (
            <span>
                <span>{playerName}</span>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 100, hide: 400 }}
                    overlay={<Tooltip>{userName}</Tooltip>}
                >
                    <span className="text-danger"> ({stringToShort(userName, 7)})</span>
                </OverlayTrigger>
            </span>
        );
    }

    useEffect(() => {
        if (!qcAuto && toastQCPromiseId == null) {
            updateToastPromise(toastQCPromiseId, DONE_QUOC_CHIEN, TOAST_TYPE.SUCCESS);
        }
        if (qcAuto) {
            const toastId = toast.loading(DANG_QUOC_CHIEN);
            setToastQCPromiseId(toastId);
        }
        return () => {
            updateToastPromise(toastQCPromiseId, '', TOAST_TYPE.DEFAULT);
        }
    }, [qcAuto])


    return (
        <Card border={onlineColor()} className="shadow mb-2 mt-2">
            <Card.Header
                className={`fw-bold h5 d-flex flex-wrap align-items-center justify-content-between text-${onlineColor()}`}>
                <div className="d-flex flex-grow-1 justify-content-between">
                    {showPlayerName()}
                    <span className="d-none d-md-inline">{playerInfo.Level}</span>
                    <span className="d-none d-md-inline">{playerInfo.ServerName}</span>
                </div>
                <div className="d-flex gap-2 flex-grow-1 justify-content-evenly">
                    {!online && <Button variant={`outline-${online == true ? 'danger' : 'success'}`} disabled={starting} onClick={handleStart}>Start</Button>}
                    {online && <Button variant={`outline-${online == true ? 'danger' : 'success'}`} onClick={handleStop}>Stop</Button>}
                </div>
            </Card.Header>
            {(screen === SCREEN_SETTING.NO_OPEN) && <Card.Body>
                <CharacterMap
                    playerId={playerId} />
                <PlayerInfo
                    playerId={playerId} />
                <PlayerSeaFood
                    playerId={playerId}
                    isFarmingSeaFood={isFarmingSeaFood} />
                <ExtendFunction playerId={playerId} />
            </Card.Body>}
        </Card>
    )
}

export default Character;